 
export const environment = {
    production: false,

    // ** Development **

    baseUrl: "https://cellc-customer-staging.agilitygis.com/api",
    integrationUrl: 'https://integration-staging.agilitygis.com/api',
    googleAnalyticsCode: 'GTM-5K79DFL',
    organisationId: '35536',

    // ** PRODUCTION **
    
    // baseUrl: "https://cellc.agilitygis.com/api",
    // integrationUrl: 'https://integration.agilitygis.com/api',
    // googleAnalyticsCode: 'GTM-5K79DFL'

    
};
